interface FolderFilterProps {
  selectedFolder: string;
  onFolderChange: (folder: string) => void;
  folderCounts: Record<string, number>;
}

export default function FolderFilter({
  selectedFolder,
  onFolderChange,
  folderCounts
}: FolderFilterProps) {
  const folders = [
    { value: 'all', label: '전체', icon: '📂' },
    { value: '출퇴근', label: '출퇴근', icon: '🚇' },
    { value: '자기 전', label: '자기 전', icon: '🌙' },
    { value: '멍때리기', label: '멍때리기', icon: '😶' },
    { value: '두뇌', label: '두뇌', icon: '🧠' }
  ];

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm border-b border-gray-700/50 sticky top-0 z-10 shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wide">폴더 필터</h3>
          <div className="flex flex-wrap gap-2">
            {folders.map(folder => {
              const count = folder.value === 'all' 
                ? Object.values(folderCounts).reduce((a, b) => a + b, 0)
                : folderCounts[folder.value] || 0;
              
              return (
                <button
                  key={folder.value}
                  onClick={() => onFolderChange(folder.value)}
                  className={`px-4 py-2 text-sm font-medium transition-all whitespace-nowrap cursor-pointer rounded-full flex items-center gap-2 ${
                    selectedFolder === folder.value
                      ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/30'
                      : 'bg-gray-700/50 text-gray-300 border border-gray-600 hover:border-cyan-500 hover:shadow-md'
                  }`}
                >
                  <span>{folder.icon}</span>
                  <span>{folder.label}</span>
                  {count > 0 && (
                    <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${
                      selectedFolder === folder.value
                        ? 'bg-white/20 text-white'
                        : 'bg-cyan-500 text-white'
                    }`}>
                      {count}
                    </span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
